import React, { useState } from 'react';
import SectionHeader from 'partial/components/SectionHeader';
import { HiDocumentAdd } from 'react-icons/hi';
import Table, { tableEditDelete } from 'partial/components/Table';
import Button from 'partial/components/Button';
import Pagination from 'partial/components/Pagination';
import { showAlert, showDrawer } from 'partial/components/Modal';
import CategoryModal from '../modals/CategoryModal';
import { useCategoryList, useDeleteCategory } from '../hooks';
import { ITEM } from '../constants';

function CategoryContainer() {
  const [filter, setFilter] = useState({ page: 1, sort: 'name:asc' });
  const [isLoading, list, meta] = useCategoryList(filter);
  const [, deleteCategory] = useDeleteCategory();

  const tableFormat = React.useMemo(() => {
    const handleEdit = (row) => {
      showDrawer({
        size: 'xs',
        title: 'Edit Category',
        content: (onClose) => <CategoryModal closeModal={onClose} data={row} />,
      });
    };
    const handleDelete = (row) => {
      showAlert({
        title: `Delete ${row?.name} Category`,
        yesLabel: 'Delete',
        isLoadingKey: ITEM,
        isLoadingMethod: 'remove',
        onYes: (closeAlert) => {
          deleteCategory(row.id, () => {
            closeAlert();
          });
        },
      });
    };
    return [
      { label: 'Name', key: 'name', id: 'name', sortKey: 'name' },
      tableEditDelete(handleEdit, handleDelete),
    ];
  }, [deleteCategory]);

  const handleAdd = () => {
    showDrawer({
      size: 'xs',
      title: 'Add Category',
      content: (onClose) => <CategoryModal closeModal={onClose} />,
    });
  };

  return (
    <div className="flex-grow flex flex-col">
      <div className="px-4 pt-5">
        <SectionHeader label="Category">
          <Button
            primary
            icon={HiDocumentAdd}
            onClick={handleAdd}
            disabled={isLoading}
          >
            Add
          </Button>
        </SectionHeader>
      </div>
      <div className="flex flex-col flex-grow bg-white">
        <Table
          data={list}
          format={tableFormat}
          isLoading={isLoading}
          onSort={setFilter}
          sort={filter.sort}
        />
      </div>
      <Pagination value={meta} onChange={setFilter} />
    </div>
  );
}

export default CategoryContainer;
